module.exports = __webpack_public_path__ + "img/Christmas-coupon-back.be865ad.png";